import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Home/HeroSection.css';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      id: 1,
      title: "Transform Your Business With Digital Excellence",
      subtitle: "We provide cutting-edge IT solutions that drive growth, enhance efficiency, and secure your digital assets.",
      buttonText: "Get Started",
      buttonLink: "/contact",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
    },
    {
      id: 2,
      title: "Secure Your Digital Infrastructure",
      subtitle: "Advanced cybersecurity solutions to protect your business from evolving threats and vulnerabilities.",
      buttonText: "Learn More",
      buttonLink: "/services",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
    },
    {
      id: 3,
      title: "Cloud Solutions for Modern Businesses",
      subtitle: "Scalable cloud computing services that adapt to your business needs and drive innovation.",
      buttonText: "Explore Services",
      buttonLink: "/services",
      image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section className="hero-section">
      <div className="hero-slides">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${slide.image})` }}
          >
            <div className="container">
              <div className="row align-items-center min-vh-100">
                <div className="col-lg-8">
                  <div className={`hero-content ${index === currentSlide ? 'animate-fade-in-up' : ''}`}>
                    <h1 className="hero-title">{slide.title}</h1>
                    <p className="hero-subtitle">{slide.subtitle}</p>
                    <div className="hero-buttons">
                      <Link to={slide.buttonLink} className="btn btn-primary">
                        {slide.buttonText}
                        <i className="bi bi-arrow-right ms-2"></i>
                      </Link>
                      <Link to="/about" className="btn btn-outline-light ms-3">
                        Learn About Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Controls */}
      <button className="hero-control prev" onClick={goToPrevSlide} aria-label="Previous slide">
        <i className="bi bi-chevron-left"></i>
      </button>
      <button className="hero-control next" onClick={goToNextSlide} aria-label="Next slide">
        <i className="bi bi-chevron-right"></i>
      </button>

      {/* Slide Indicators */}
      <div className="slide-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Scroll Down Indicator */}
      <div className="scroll-down">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <div className="arrow">
          <i className="bi bi-chevron-down"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;